import RestaurantCard from "./RestaurantCard";
import { useState } from "react";
import ImageCarouselModal from "./ImageCarouselModal";

function TrendingRestaurants({ restaurants }) {
  const [openPhotos, setOpenPhotos] = useState(false);
  const [currentPhotos, setCurrentPhotos] = useState([]);

  const openGallery = (restaurant) => {
    // Use photos from restaurant data (persisted in DB) or fallback to single imageUrl
    const photos = restaurant.photos && restaurant.photos.length > 0 ? restaurant.photos : [restaurant.imageUrl];
    setCurrentPhotos(photos);
    setOpenPhotos(true);
  };

  const closeGallery = () => {
    setOpenPhotos(false);
    setCurrentPhotos([]);
  };

  return (
    <section id="trending-restaurants" className="bg-gray-50 py-24">

      <div className="max-w-7xl mx-auto px-4">

        {/* Section Header */}
        <div className="text-center mb-12">

        <h2 className="text-4xl md:text-5xl font-luxury font-semibold text-luxury-dark mb-6 tracking-wide">
          <span className="brand-orange-text">Restaurants</span> Near You
        </h2>


          <div className="w-16 h-1 brand-orange-bg mx-auto mt-4 mb-6 rounded-full"></div>

          <p className="text-gray-600 text-sm md:text-base">
            Our curated collection of exceptional dining destinations for epicurean adventures.
          </p>

        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {restaurants.slice(0, 4).map((restaurant) => (
            <RestaurantCard key={restaurant.id} restaurant={restaurant} onOpenGallery={openGallery} />
          ))}
        </div>

        {openPhotos && (
          <ImageCarouselModal photos={currentPhotos} initialIndex={0} onClose={closeGallery} />
        )}

      </div>

    </section>
  );
}

export default TrendingRestaurants;
